export default {
    NOTA_FISCAL: 1,
    OUTRAS: 2,
    DOACAO: 3,
    DEVOLUCAO: 4,
}